import { createSlice } from "@reduxjs/toolkit";
import {
  addProject,
  deleteProject,
  getProjectById,
  updateProject,
} from "./thunk";

interface KanbanboardStateType {
  projects: Array<any>;
  project: any;
  error?: string | object | null | undefined | unknown;
}
export const initialState: KanbanboardStateType = {
  projects: [],
  project: null,
  error: {},
};

const kanbanboardSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    resetProject: (state: any) => {
      state.project = null;
    },
  },
  extraReducers: builder => {
    builder.addCase(addProject.fulfilled, (state: any, action: any) => {
      state.projects.push(action.payload);
    });
    builder.addCase(addProject.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(updateProject.fulfilled, (state: any, action: any) => {
      state.projects = state.projects.map((project: any) =>
        project.id === action.payload.id
          ? { ...project, ...action.payload }
          : project
      );
    });
    builder.addCase(updateProject.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(deleteProject.fulfilled, (state: any, action: any) => {
      state.projects = state.projects.filter(
        (project: any) => project.id !== action.payload
      );
    });
    builder.addCase(deleteProject.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(getProjectById.fulfilled, (state: any, action: any) => {
      state.project = action.payload;
    });
    builder.addCase(getProjectById.rejected, (state, action) => {
      state.error = action.payload || null;
    });
  },
});

export const { resetProject } = kanbanboardSlice.actions;
export default kanbanboardSlice.reducer;
